<ion-grid class="ion-no-padding stepper">
  <ion-row  class="ion-no-padding">
    <ion-col class="ion-no-padding" size="4">
      <ion-button [color]="(1 === currentStep)? 'secondary': 'medium'" [routerLink]="['../../../']" mode="ios" class="btn--small stepper__btn ion-no-padding ion-no-margin" expand="full"
      [disabled]="( +activatedSteps < 1 ) ? 'true': 'false'">
        <div>Izberi termin</div>
      </ion-button>
    </ion-col>

    <ion-col class="ion-no-padding" size="4">
      <ion-button [color]="(2 === currentStep)? 'secondary': 'medium'" [routerLink]="['../../../../izberi-termin']" mode="ios" class="btn--small stepper__btn--active ion-no-padding ion-no-margin"
      expand="full" [disabled]="( +activatedSteps < 2 ) ? 'true': 'false'">
        <div>Predogled</div>
      </ion-button>
    </ion-col>

    <ion-col class="ion-no-padding" size="4">
      <ion-button [color]="(3 === currentStep)? 'secondary': 'medium'" [routerLink]="['../../../../predogled']" mode="ios" class="btn--small stepper__btn ion-no-padding ion-no-margin" expand="full"
      [disabled]="( activatedSteps < 3 )? true: false">
        <div>Plačilo</div>
      </ion-button>
    </ion-col>

  </ion-row>
</ion-grid>

<!--<ion-grid  class="ion-no-padding">
  <ion-row  class="ion-no-padding">
    <ion-col class="ion-no-padding" size="4">
      <ion-button [color]="(1 === currentStep)? 'secondary': 'primary'" [routerLink]="['../../../../']" mode="ios" size="small" class="ion-no-padding" expand="full" [disabled]="( +activatedSteps < 1 ) ? 'true': 'false'">
        <div>1.</div>
        <div>Izberi storitve</div>
      </ion-button>
    </ion-col>

    <ion-col class="ion-no-padding" size="4">
      <ion-button [color]="(2 === currentStep)? 'secondary': 'primary'" [routerLink]="['../../../../izberi-termin']" mode="ios" size="small" class="ion-no-padding" expand="full" [disabled]="( +activatedSteps < 2 ) ? 'true': 'false'"

      >
        2.
        Izberi termin
      </ion-button>
    </ion-col>

    <ion-col class="ion-no-padding" size="4">
      <ion-button [color]="(3 === currentStep)? 'secondary': 'primary'" [routerLink]="['../../../../predogled']" mode="ios" size="small" class="ion-no-padding" expand="full" [disabled]="( activatedSteps < 3 )? true: false">
        3.
        Predogled
      </ion-button>
    </ion-col>

  </ion-row>
</ion-grid>-->